import { inject, Injectable } from '@angular/core';
import { SimpleApi } from '@core/api/simple.api';
import { TableDatasource } from '@core/api/table.datasource';
import { LeverandoerOpkraevning } from './leverandoer-opkraevning.model';
import { LeverandoerOpkraevningSearchParams } from './leverandoer-opkraevning-search/leverandoer-opkraevning-search-params.model';

@Injectable({
  providedIn: 'root',
})
export class LeverandoerOpkraevningDatasource extends TableDatasource<
  LeverandoerOpkraevning,
  LeverandoerOpkraevningSearchParams
> {
  endpoint = '/api/admin/leverandoeropkraevninger';
  defaultSortField = 'leverandoerOpkraevningPeriode.opkraevningsPeriodeFra';
  override defaultDescending = true;

  simpleApi = inject(SimpleApi);
}
